// icons
import email from '@iconify/icons-carbon/email';
import phone from '@iconify/icons-carbon/phone';
// @mui
import { Avatar, Button, Divider, Link, Stack, Typography } from '@mui/material';
import { imageProps } from '@utils/image';
import { ProjectProps } from 'src/@types/project';
import { useResponsive } from 'src/hooks';
// components
import { Iconify, TextIconLabel } from '../../components';
import linkIcon from '@iconify/icons-carbon/launch';

// ----------------------------------------------------------------------

type Props = {
  project: ProjectProps;
};

export default function ProjectHeader({ project }: Props) {
  const { title, description, projectCategory, externalURL } = project;
  const isDesktop = useResponsive('up', 'sm');

  return (
    <>
      <Stack
        spacing={1}
        sx={{
          mb: { xs: 3, md: 3 },
        }}
      >
        <Typography variant="overline" sx={{ color: 'text.secondary' }}>
          {projectCategory.name}
        </Typography>
        <Typography variant="h3" component="h1" sx={{ flexGrow: 1, pr: { md: 10 } }}>
          {title}
        </Typography>
      </Stack>
      <Typography sx={{ mb: 4 }}>{description}</Typography>
      {externalURL && (
        <a href={externalURL}>
          <Button variant="contained" color="inherit" endIcon={<Iconify icon={linkIcon} />}>
            Les mer
          </Button>
        </a>
      )}
    </>
  );
}
